import React, { Fragment } from 'react';
import {
    List,
    Datagrid,
    TextField,
    CardActions,
    Filter,
    SearchInput,
    ExportButton,
    downloadCSV,
    SelectField,
    EditButton
} from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import UnselectAllButton from '../common/UnselectAllButton';
import BulkDeleteButton from '../common/BulkDeleteButton';
import EditIcon from '../../icon/IcnEdit';
import ExportIcon from '../../icon/IcnExportListDevice';
import DateField from '../common/DateField';

const TerminalFilter = (props) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn label='resources.terminals.fields.search' />
    </Filter>
);

const csvExporter = (records, fetchRelatedRecords) => {
    const csv = convertToCSV({
        data: records,
        fields: ['id', 'appName', 'appVersion', 'lastAccessDateTime', 'name']
    });
    const bom = "\uFEFF"
    downloadCSV(bom + csv, 'terminals');
};

const TerminalBulkActionButtons = props => (
    <Fragment>
        <UnselectAllButton {...props} />
        <BulkDeleteButton {...props} dialogGuidance='resources.terminals.fields.deleteGuidance' />
    </Fragment>
);

const TerminalActions = ({
    bulkActions,
    basePath,
    currentSort,
    displayedFilters,
    exporter,
    filters,
    filterValues,
    onUnselectItems,
    resource,
    selectedIds,
    showFilter
}) => (
        <CardActions>
            {bulkActions && React.cloneElement(bulkActions, {
                basePath,
                filterValues,
                resource,
                selectedIds,
                onUnselectItems,
            })}
            {filters && React.cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {
                <ExportButton
                    resource={resource}
                    sort={currentSort}
                    filter={filterValues}
                    exporter={exporter}
                    icon={<ExportIcon />}
                />
            }
        </CardActions>
    );


const TerminalList = props => (
    <List {...props}
        bulkActionButtons={<TerminalBulkActionButtons />}
        actions={<TerminalActions />}
        filters={<TerminalFilter />}
        exporter={csvExporter}
        sort={{ field: 'status', order: 'DESC' }}
    >

        <Datagrid>
            <TextField source="name" />
            <TextField source="appName" />
            <TextField source="appVersion" />
            <SelectField
                source="status"
                choices={[
                    { id: 0, name: 'resources.terminals.enums.status.registered' },
                    { id: 1, name: 'resources.terminals.enums.status.connected' },
                    { id: 2, name: 'resources.terminals.enums.status.disconnected' },
                    { id: 3, name: 'resources.terminals.enums.status.refused' },
                ]} />
            <DateField source="lastAccessDateTime" showTime={true} />
            <TextField source="id" />
            <EditButton icon={<EditIcon />} />
        </Datagrid>
    </List>
);

export default TerminalList;